
// => Styling
import styles from './OverlayFx.module.css';


// ============
// Component
// ============
const OverlayFx = ({ enabled = true }) => {


    // RENDER
    // ---------
    return(
        enabled && <div className={styles.container} />
    )
}


export default OverlayFx